import { infos_to_display } from "../settings";
import { Description } from "./Description";
import { ExifComponent } from "./ExifComponent";
import { Title } from "./Title";
import { useState } from "preact/hooks";
import { MwlIcons } from "../components/MwlIcons";
import { buildVisibleExifList } from "./exifFields";

import i18n from '@i18n';

// Standalone metadata card component that doesn't use context
// Used by PhotoSwipe and can be reused anywhere
export const MetadataCard = ({ className, image, onCloseClick, onCollapsedChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const visibleExifs = buildVisibleExifList(image, infos_to_display);

  if (!image) {
    return null;
  }

  const toggleCollapse = (e) => {
    e.stopPropagation();
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    if (onCollapsedChange) {
      onCollapsedChange(newCollapsedState);
    }
  };

  const wrapperClass = className ? `${className} ${isCollapsed ? 'collapsed' : ''}` : isCollapsed ? 'collapsed' : '';

  return (
    <>
      {/* Two separate buttons to avoid transition effects when switching icons */}
      {infos_to_display.metadata_toggle && (
        isCollapsed ? (
          <button
            className="mwl__metadata__toggle mwl__metadata__toggle--show"
            onClick={toggleCollapse}
            aria-label={i18n.TOOLBAR.SHOW_METADATA}
          >
            <MwlIcons icon="camera" />
          </button>
        ) : (
          <button
            className="mwl__metadata__toggle mwl__metadata__toggle--hide"
            onClick={toggleCollapse}
            aria-label={i18n.TOOLBAR.HIDE_METADATA}
          >
            <MwlIcons icon="close" />
          </button>
        )
      )}

      <div className="mwl__metadata__content">
        <Title image={image} />
        <Description image={image} />

        <div className="exifs" onClick={onCloseClick}>
          {visibleExifs.map(v => <ExifComponent {...v} />)}
        </div>
      </div>
    </>
  );
};
